module.exports = __webpack_public_path__ + "static/media/18-speaker_profile.04cac1f2.webp";